import "./Welcome.css"

import {useLocation, useNavigate} from "react-router-dom";
import {useClientLocale} from "../../context/client_locale";
import {useAdaptiveMobileSize} from "../../hooks/useAdaptiveMobileSize";

import PlainControl from "../../components/plainControl/PlainControl";
import {ErrorMessage} from "../../components/errorMessage/ErrorMessage";

import {remoteFilePath} from "../../services/api/File";
import {getStyleForClientRootContainer} from "../../helper/client_block_style";

import {getActualResolutionCategory, getWindowSize} from "../../utils/size";

export default function Welcome() {
    const adaptiveMobileSize = useAdaptiveMobileSize();
    const navigate = useNavigate();
    const state = useLocation().state
    const isMobileVersion = state.isMobileVersion;
    let exhibition = null
    if (state) {
        exhibition = state.exhibition
    }
    const { strings } = useClientLocale();
    const resolutionUnit = getActualResolutionCategory(
        isMobileVersion ? adaptiveMobileSize : getWindowSize()
    )
    let backgroundURL = null

    let mainContent
    if (!exhibition) {
        mainContent = (
            <div className={"h-full w-full flex flex-col justify-center"}>
                <ErrorMessage>{strings["wrong_parameters"]}</ErrorMessage>
            </div>
        )
    } else {
        const chooseLanguageID = exhibition.backgroundImages["Choose language"]
        backgroundURL = remoteFilePath(chooseLanguageID)
        function nextHandle() {
            navigate("/languages", {state: state})
        }
        mainContent = (
            <>
                <div className={"h-full w-full flex flex-col"}>
                    <div className={"basis-3/4 grow"}></div>
                    <div className={"basis-1/4 grow"}>
                        <PlainControl
                            resolutionUnit={resolutionUnit}
                            onClick={nextHandle}
                        >
                            {strings["next"].toUpperCase()}
                        </PlainControl>
                    </div>
                </div>
            </>
        );
    }
    const containerStyle = getStyleForClientRootContainer(backgroundURL, adaptiveMobileSize, isMobileVersion);
    return (
      <div className="flex flex-row justify-center">
        <div className="bg-center bg-no-repeat" style={containerStyle}>
          {mainContent}
        </div>
      </div>
    )
}
